/**
 * Created by shaun on 16/09/2017.
 */

import SearchStore from 'module/search';
import common from 'module/common';
import queryString from 'query-string';

const SET_LABEL = 'label';
const SET_QUERY = 'query';
const SET_WORKFLOW = 'workflow';
const SET_DEFAULT_WINDOW = 'defaultWindow';
const SET_SEARCH_STORE = 'searchStore';
const RESET_ALL_SEARCH_STORES = 'resetAllSearchStores';
const SET_SEARCH_HISTORY = 'searchHistory';
const SET_MENU_TOGGLES = 'menuToggles';
const SET_SELECTED_PLOT = 'selectedPlot';
const SET_OVERALL_TOTAL = 'overallTotal';
const SET_DROPDOWN_TOGGLE = 'dropdownToggle';
const SELECT_PRODUCT = 'selectProduct';
const SET_PRODUCTS = 'products';
const SET_ORDERS = 'orders';

// initial state
const state = {
  label: null,
  query: {},
  workflow: {
    entity: null,
    id: null,
    workflow: null
  },
  defaultWindow: {
    minimised: false,
    leftControls: [],
    controls: []
  },
  searchStore: {},
  menuToggles: {},
  dropdownToggle: null,
  searchHistory: [],
  selectedPlot: {},
  overallTotal: 0,
  selectedProduct: null,
  products: [],
  orders: [],
};

//actions
const actions = {
  initState({commit}) {
    commit(SET_QUERY, queryString.parse(window.location.search))
  },
  label({commit}, label) {
    commit(SET_LABEL, label);
  },
  workflow({commit}, {workflow, entity, id}) {
    commit(SET_WORKFLOW, {workflow, entity, id});
  },
  defaultWindow({commit}, defaultWindow) {
    commit(SET_DEFAULT_WINDOW, _.merge({}, state.defaultWindow, defaultWindow));
  },
  searchStore({commit}, {type, searchStore}) {
    if (searchStore instanceof SearchStore) {
      commit(SET_SEARCH_STORE, {type, searchStore});
    } else {
      throw new Error('Invalid Search Store');
    }
  },
  resetAllSearchStores({commit}) {
    commit(RESET_ALL_SEARCH_STORES);
  },
  selectMenu({state, commit}, menus) {
    // Removes empty elements from menus
    menus = menus.filter(function (element) {
      return element;
    });
    let filterClicked = menus[menus.length - 1];

    let menuToggles = {};

    _.each(menus, function (value) {
      menuToggles[value] = true;
    });

    if (state.menuToggles[filterClicked] === true) {
      menuToggles[filterClicked] = false;
    }

    commit(SET_MENU_TOGGLES, menuToggles);
  },
  clearMenu({state, commit}) {
    commit(SET_MENU_TOGGLES, {});
  },
  selectDropdown({commit}, dropdown) {
    commit(SET_DROPDOWN_TOGGLE, dropdown);
  },
  addHistoryItem({state, commit}, searchText) {
    let newHistory = _.cloneDeep(state.searchHistory);

    if (state.searchHistory.length === 5) {
      newHistory.shift();
    }

    newHistory.push(searchText);
    commit(SET_SEARCH_HISTORY, newHistory);
  },
  removeHistoryItem({state, commit}, searchText) {
    let newHistory = _.cloneDeep(state.searchHistory);

    newHistory.splice(newHistory.indexOf(searchText), 1);
    commit(SET_SEARCH_HISTORY, newHistory);
  },
  selectPlot({state, commit}, {plot, plotName, workSection, startDate, endDate}) {
    let obj = {
      plot,
      plotName
    };

    if (workSection !== undefined) {
      obj.workSection = workSection;
      obj.startDate = startDate;
      obj.endDate = endDate;
    }
    commit(SET_SELECTED_PLOT, obj);
  },
  selectProduct({state, commit, rootGetters, dispatch}, {branch, productCode}) {

    let product = state.products.filter((product) => {
      return product.code === productCode;
    })[0] || null;

    if (product === null) {
      let idToken = rootGetters['user/idToken']();

      common.httpPost('product')
        .data({
          idToken,
          branchNumber: branch.number,
          productCode
        })
        .then((res) => {
          commit(SELECT_PRODUCT, res.data);
        }, (error) => {
          dispatch('error/error', error, {root: true});
        });
    } else {
      commit(SELECT_PRODUCT, product);
    }
  },
  setOverallTotal({commit}, overallTotal) {
    commit(SET_OVERALL_TOTAL, overallTotal);
  },
  getProducts({state, commit, rootGetters, dispatch}, {branch, query}) {
    let idToken = rootGetters['user/idToken']();

    common.httpPost('product')
      .data({
        idToken,
        branchNumber: branch.number,
        search: query
      })
      .then((res) => {
        commit(SET_PRODUCTS, res.data);
      }, (error) => {
        dispatch('error/error', error, {root: true});
      });
  },
  unselectPlot({state, commit}) {
    commit(SET_SELECTED_PLOT, {});
  }
};

//getters
const getters = {};

// mutations
const mutations = {
  [SET_LABEL](state, label) {
    state.label = label;
  },
  [SET_QUERY](state, query) {
    state.query = _.cloneDeep(query);
  },
  [SET_WORKFLOW](state, {entity, workflow, id}) {
    state.workflow.entity = entity;
    state.workflow.workflow = workflow;
    state.workflow.id = id;
  },
  [SET_DEFAULT_WINDOW](state, defaultWindow) {
    state.defaultWindow = defaultWindow
  },
  [SET_SEARCH_STORE](state, {type, searchStore}) {
    state.searchStore[type] = searchStore;
  },
  [RESET_ALL_SEARCH_STORES](state) {
    state.searchStore = {};
  },
  [SET_SEARCH_HISTORY](state, searchHistory) {
    state.searchHistory = searchHistory;
  },
  [SET_MENU_TOGGLES](state, menuToggles) {
    state.menuToggles = menuToggles;
  },
  [SET_DROPDOWN_TOGGLE](state, dropdownToggle) {
    state.dropdownToggle = dropdownToggle;
  },
  [SET_SELECTED_PLOT](state, workSection) {
    state.selectedPlot = workSection;
  },
  [SET_OVERALL_TOTAL](state, overallTotal) {
    state.overallTotal = overallTotal;
  },
  [SELECT_PRODUCT](state, product) {
    state.selectedProduct = product;
  },
  [SET_PRODUCTS](state, products) {
    state.products = products;
  },
  [SET_ORDERS](state, orders) {
    state.orders = orders;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}